import React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { CategoryExtensionProps } from '../category/category-manager';
import type { DeliveryType } from '../commons/utils/delivery-time';
import { useSessionState } from '../global-state';
import { DeliveryDate } from './delivery-date';
import { DeliveryTime } from './delivery-time';

export const DeliveryTimeExtension: React.FC<CategoryExtensionProps> = ({
  category,
  selected,
  selectedOption,
  selectedChoice,
}) => {
  const { locale } = useTranslations();
  const session = useSessionState();
  const isPreorder = session.cart.is_preorder;

  const deliveryTime = selectedOption.delivery_times!.find(
    time => time.id === selectedChoice.time_slot_ref
  );
  const type = category.delivery_type as DeliveryType;

  if (isPreorder && deliveryTime) {
    return (
      <DeliveryDate
        ellipsisOn={!selected}
        locale={locale}
        deliveryTime={deliveryTime}
        asShippingWeek={isPreorder}
        data-test="delivery-time"
      />
    );
  }

  return deliveryTime ? <DeliveryTime deliveryTime={deliveryTime} type={type} /> : null;
};
